import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from '../../constants';


const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const FETCH_RECURLY_PLANS = createApiNamespacedConstants('FETCH_RECURLY_PLANS');

export const SELECT_PLAN = `${NAMESPACE}/SELECT_PLAN`;
export const BATCH_SELECT_PLAN = `${NAMESPACE}/BATCH_SELECT_PLAN`;
